import React from 'react';
import ParentDashboard from '../domains/parent/components/ParentDashboard';

const ParentDashboardPage: React.FC = () => {
  return <ParentDashboard />;
};

export default ParentDashboardPage;